<template>
  <div class="layer notranslate">
    <div class="inner">
      <div v-if="!isTime">
        <div class="message warn">
          <p class="mb15">{{locale.not_available_time}}</p>
          <p>{{locale.available_service_time}}</p>
          <p class="em colorPrimary">{{locale.dayof_checkin}}<br>({{availableTime}})</p>
        </div>
      </div>
      <div v-else-if="!isActive">
        <div class="message warn">
          <p>{{locale.inactive_service}}</p>
        </div>
      </div>
      <div v-else>
        <div class="message">
          <p class="em colorPrimary mb15">{{locale.message_express_checkin_message_1}}</p>
          <p class="">{{locale.express_checkin_available_time}}<br>({{availableTime}})</p>
        </div>
        <div class="formBtn mt30">
          <button type="button" class="btn btnRound btnWhite mr5" @click="goMain">{{locale.no}}</button>
          <button type="button" class="btn btnRound" @click="close">{{locale.yes}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'expressCheckin',
  props: [
    'locale'
  ],
  computed: {
    isActive () {
      return this.info.active
    },
    isTime () {
      const from = moment().set({ hour: this.info.hourFrom, minute: 0, second: 0 })
      const to = moment().set({ hour: this.info.hourTo, minute: 0, second: 0 })
      const now = moment()
      return now.isSameOrAfter(from) && now.isSameOrBefore(to)
    },
    availableTime () {
      function pad (num) {
        return `${String('0' + num).slice(-2)}:00`
      }
      return `${pad(this.info.hourFrom)} ~ ${pad(this.info.hourTo)}`
    }
  },
  created () {
    document.body.classList.add('layerOn')
    this.$store.dispatch('authentication/getExpressCheckinInfo').then((res) => {
      if (res) {
        this.info = { ...this.info, ...res }
      } else {
        this.info.active = false
      }
    })
  },
  destroyed () {
    document.body.classList.remove('layerOn')
  },
  data () {
    return {
      info: {}
    }
  },
  methods: {
    goMain () {
      if (window.confirm(this.locale.go_stayguide_main)) {
        this.$router.push({
          name: 'main'
        })
      }
    },
    close () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  align-items: flex-start;
  padding: 200px 15px 90px;
  background-color: $color-white;
  z-index: 8;
  .inner {
    margin-top: -60px;
    text-align: center;
  }
  .message {
    position: relative;
    padding-top: 90px;
    font-size: 1.1em;
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 64px;
      background-image: url('~@/assets/img/mobile_check.png');
      background-position: 50% 50%;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 0.3;
    }
    &.warn:before {
      background-image: url('~@/assets/img/mobile_warn.png');
    }
    .em {
      font-size: 1.2em;
    }
  }
}
@media screen and (min-width: 768px) {
  #app:not(.noFrame) {
    .layer {
      left: 80px;
    }
  }
}
@media screen and (min-width: 800px) {
  #app:not(.noFrame) {
    .layer {
      left: 180px;
    }
  }
}
@media screen and (min-width: 1024px) {
  #app:not(.noFrame) {
    .layer {
      left: 240px;
    }
  }
}
</style>
